
import React, { Component } from 'react';
import '../styles/hoverGrowImage.css';

class HoverGrowImage extends Component {
  render() {
    return (
	  <div className="hover-grow-image-container">
		<img alt="" className="hover-grow-image full-width" src={this.props.image} />
	  </div>
    );
  }
}

export default HoverGrowImage;



// WEBPACK FOOTER //
// ./src/components/hoverGrowImage.js